import React from "react";
import { CustomLinearProgressTop } from "./loading/Progress.jsx";
import { ServiceErrorAlert } from "./Error.jsx";
import { TurnrActionAlert } from "./alerts/TurnrAlert.jsx";
import { serviceIsLoading, serviceIsSuccessfullyFetched } from "rylak-common";
import ShopSelect from "./input/selects/ShopSelect.jsx";
import { getBrandName } from "../cores/brandCore";

function PleaseSelectABrand({ orMerchant, className }) {
    return (
        <>
            <TurnrActionAlert className={className} variant="outlined">
                Please select a <b>Shop</b>{" "}
                {orMerchant && (
                    <>
                        or <b>Merchant</b>
                    </>
                )}{" "}
                to view this page
            </TurnrActionAlert>
        </>
    );
}

export default function BrandNeededWrapper({ appProps, children, alertProps }) {
    const { brandService, selectedBrandId } = appProps;
    return (
        <>
            <ServiceErrorAlert serviceData={brandService} {...alertProps} />
            {serviceIsLoading(brandService) ? (
                <CustomLinearProgressTop />
            ) : !selectedBrandId ? (
                <>
                    <PleaseSelectABrand {...alertProps} />
                    {appProps && (
                        <div style={{ marginTop: "20px" }}>
                            <ShopSelect
                                appProps={appProps}
                                value={selectedBrandId}
                                onChange={appProps?.setSelectedBrandId}
                                selectNoneComponent={"All Shops"}
                                title={"Select shop"}
                                loading={false}
                                fullWidth={false}
                                renderSelected={(option) => {
                                    return getBrandName(option?.brand) || "-";
                                }}
                            />
                        </div>
                    )}
                </>
            ) : (
                serviceIsSuccessfullyFetched(brandService) && children
            )}
        </>
    );
}
